/**
 * global.ts - 全局配置
 * @Author: 徐昭 <zhao.xu@hand-china.com>
 * @Date: 2020/9/28 9:54
 * @LastEditTime: 2020/9/28 9:54
 * @Copyright: Copyright (c) 2020, Hand
 */
import '@common/config/customize';
import { setLayout } from 'hzero-front/lib/customize/layout';
import './resize.js';
import './index.less';

// eslint-disable-next-line global-require
export const dvaRootRouter = () => require('./router').default;
export const dvaAppInit = () => {
  // 全局配置-侧边展开布局
  setLayout('side-all', async () => import('./layouts/CommonLayout'), true);
};
